import*as o from"styled-components";import{getDefaultExportFromNamespaceIfNotNamed as m}from"./_commonjsHelpers.js";var r=m(o);export{r as default};
//# sourceMappingURL=_styled-components.js.map
